import { Th, Tr, Wrapper } from './footerStyle';

interface IProps {
  footerGroups;
  borders?: boolean;
  lines?: number;
}

const FooterView = ({ footerGroups, borders, lines }: IProps) => {
  return (
    <Wrapper>
      {footerGroups.map((footerGroup) => (
        <Tr // eslint-disable-line react/jsx-key
          {...footerGroup.getFooterGroupProps()}
          borders={borders}
        >
          {footerGroup.headers.map((column) => (
            <Th
              key={column.id}
              {...{
                ...column.getFooterProps(column.getSortByToggleProps()),
                lines,
                style: {
                  flex: column?.flex || column.width,
                  minWidth: column.minWidth,
                },
              }}
            >
              {column.render('Footer')}
            </Th>
          ))}
        </Tr>
      ))}
    </Wrapper>
  );
};

export default FooterView;
